<template>
  <span>{{ getDate }}</span>
</template>

<script>
export default {
  name: "DateOutput",
  props: ["dateString"],
  computed: {
    getDate() {
      if (!this.dateString) return "";
      const date = new Date(this.dateString);
      return date ? date.toLocaleDateString("en-GB") : this.dateString;
    }
  }
};
</script>
